<template>
  <v-badge
    :content="cellData.length ? cellData.length : '0'"
    color="#3B82F6"
    overlap
    offset-x="10"
    offset-y="10"
    class="image-preview-icon"
  >
    <image-field
      :src="config.src || '/img/icons/table-image-icon.svg'"
      width="20"
      height="20"
      contain
      @onClick="onClick"
    />
  </v-badge>
</template>

<script>
import ImageField from '@/global/components/fields/ImageField.vue'

export default {
  name: 'TableImageIconWithCounter',

  components: {
    ImageField
  },

  props: {
    cellData: {
      type: Array,
      default: () => ([])
    },
    config: {
      type: Object,
      default: () => ({})
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    onClick () {
      const { onClick } = this.config || {}

      if (typeof onClick === 'function') {
        onClick({
          data: this.cellData,
          rowData: this.rowData
        })
      }
    }
  }
}
</script>

<style scoped>
.image-preview-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.image-preview-icon:hover {
  cursor: pointer;
}
</style>
